export default {"src":"/_next/static/media/semi-detached-farmhouses-icon-selected.77227ffb.svg","height":88,"width":111,"blurWidth":0,"blurHeight":0};